//https://stackoverflow.com/a/68810695/5231665
import { useCallback, useEffect, useState } from "react";

export default function useLocalStorage(key, initialValue) {
	const initialize = (key) => {
		try {
			const item = localStorage.getItem(key);
			if (item && item !== "undefined") {
				return JSON.parse(item);
			}

			localStorage.setItem(key, JSON.stringify(initialValue));
			return initialValue;
		} catch {
			return initialValue;
		}
	};

	const [state, setState] = useState(initialValue);

	// solution is here....
	useEffect(() => {
		setState(initialize(key));
	}, []);

	const setValue = (value) => {
		try {
			const valueToStore = value instanceof Function ? value(state) : value;
			setState(valueToStore);
			localStorage.setItem(key, JSON.stringify(valueToStore));
		} catch (error) {
			console.error(error);
		}
	};

	return [state, setValue];
}
